var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 121",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-407.976,-1532.58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,-638.978,-301.057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.24196,11.5384)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0,0,0.535047,539.253,260.93)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 534.108,
    cy: 1384.9,
    r: 60.497,
    style: {
      fill: "rgb(255,193,7)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.90301,0,0,0.534882,17.204,762.528)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36273,0.350747,-0.231135,0.413974,784.081,-301.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.375161,0.3388,-0.433555,-0.224816,1937.63,119.548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.518077,-0.0118281,-0.138822,-0.449494,1949.72,748.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0124814,0.490964,-0.474318,0.131556,1459.41,-317.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.3px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.817406,0.338816,-0.377972,0.818925,377.877,-305.752)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36273,0.350747,-0.231135,0.413974,784.081,-301.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "8.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.375161,0.3388,-0.433555,-0.224816,1937.63,119.548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "8.19px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.518077,-0.0118281,-0.138822,-0.449494,1949.72,748.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "8.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0124814,0.490964,-0.474318,0.131556,1459.41,-317.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "8.18px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5196,0,0,0.476593,418.741,146.981)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1391.76,
    cy: 630.663,
    r: 50.977,
    style: {
      fill: "white",
      stroke: "rgb(255,193,7)",
      strokeWidth: "4.13px"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv);
export default __webpack_public_path__ + "static/media/pv.e0cda6271a50c03ed6f8eb4cd9b89e39.svg";
export { ForwardRef as ReactComponent };